import { ReactComponent as AllDocuments } from 'icons/documents-prism-16.svg'
import { ReactComponent as SharedWithMe } from 'icons/person-circle-prism-16.svg'
import { ReactComponent as LinkLibrary } from 'icons/link-library-prism-16.svg'
import { ReactComponent as Trash } from 'icons/trash-empty-prism-16.svg'
import { ReactComponent as FolderClosed } from 'icons/folder-closed-16.svg'
import { ReactComponent as FolderOpen } from 'icons/folder-open-16.svg'
import { ReactComponent as MyDraftsProject } from 'icons/my-drafts-prism-16.svg'
import { ReactComponent as PersonIcon } from 'icons/person-prism-16.svg'
import { ReactComponent as BellIcon } from 'icons/bell-prism-16.svg'
import { ReactComponent as GearIcon } from 'icons/gear-prism-16.svg'
import { ReactComponent as LifeBelt } from 'icons/lifebelt-16.svg'
import { ReactComponent as Home } from 'icons/home-16.svg'
import { ReactComponent as MailEnvelope } from 'icons/mail-envelope-16.svg'
import { ReactComponent as Notebook } from 'icons/notebook-16.svg'
import { ReactComponent as QuestionMark } from 'icons/question-mark-16.svg'
import { ReactComponent as SketchLogo } from 'icons/sketch-logo-16.svg'

export const icons = {
  AllDocuments,
  SharedWithMe,
  LinkLibrary,
  Trash,
  FolderClosed,
  FolderOpen,
  MyDraftsProject,
  PersonIcon,
  BellIcon,
  GearIcon,
  LifeBelt,
  Home,
  MailEnvelope,
  Notebook,
  QuestionMark,
  SketchLogo,
}
